import { itemAsideClasses, itemBodyClasses, itemClasses, itemTitleClasses } from "./style";
import AttachmentIcon from "../AttachmentIcon";
import { Link } from "react-router-dom";
import { changesSummaryClasses } from "../Attachment/style";
import { FontIcon } from "@fluentui/react";
import React from "react";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

type Props = {
  savedAttachment: any;
};

const SavedAttachmentItem: React.FC<Props> = (props) => {
  const { savedAttachment } = props;

  const appInsights = useAppInsightsContext();

  return (
    <div className={itemClasses}>
      <div className={itemAsideClasses}>
        <AttachmentIcon size={16} type={savedAttachment.attachmentType} />
      </div>
      <div className={itemBodyClasses}>
        <a
          className={itemTitleClasses}
          href={savedAttachment.savedAttachment}
          target="_blank"
          onClick={() => {
            appInsights.trackEvent({ name: "iManage link" });
          }}
        >
          {savedAttachment.attachmentName}
        </a>
        {savedAttachment.changesSummary && (
          <div>
            <Link
              to={`/changes-summary/${savedAttachment.attachmentId}`}
              className={changesSummaryClasses}
              onClick={() => {
                appInsights.trackEvent({ name: "View changes" });
              }}
            >
              <FontIcon
                aria-label="BranchPullRequest"
                iconName="BranchPullRequest"
                style={{ fontSize: 14, marginRight: 7 }}
              />{" "}
              {savedAttachment.changesSummary}
            </Link>
          </div>
        )}
        <div>{savedAttachment.attachmentComment}</div>
      </div>
    </div>
  );
};

export default SavedAttachmentItem;
